import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Stack } from "@similarweb/ui-components/foundations";

export const StyledCrmEnrichmentJobReviewCreditsContainer = styled(Stack)`
    flex: none;
    align-items: center;
    justify-content: center;

    width: 222px;
    height: 208px;
    padding: 24px 0;
    margin-top: 18px;

    box-sizing: border-box;
    border-radius: 10px;
    border: 1px solid ${colorsPalettes.blue[200]};
    box-shadow: 0px 3px 6px 0px rgba(14, 30, 62, 0.08);
`;
